import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input } from '@angular/core';
import { InputModel } from '../../form/inputs.model';
import { TranslateService } from '@ngx-translate/core';
import { DistributionPassengersService } from 'projects/common/services/distribution-passengers.service';

export interface DistributionPassengers {
  adults: number;
  minors: number;
}

@Component({
  selector: 'distribution-passengers-content-modal',
  template: `
      <div class="distribution-passengers-content">
        <div class="passenger-container">
          <steppers-input [model]="model[0]" [formData]="distributionData" (groupedInputsUpdateEvent)="updateFormData()"></steppers-input>
        </div>

        <div class="passenger-container">
          <steppers-input [model]="model[1]" [formData]="distributionData" (groupedInputsUpdateEvent)="updateFormData()"></steppers-input>
        </div>
        <div class="passenger-container -eva-3-center" *ngFor="let minor of [].constructor(this.distributionData.minors); let i = index">
          <div class="minor-ages-selector">
            <selector-input [model]="modelSelector[i]" [formData]="distributionData" (groupedInputsUpdateEvent)="updateFormData()" [showValidations]="distributionPassengersService.showValidation"></selector-input>
          </div>
        </div>
        <p *ngIf="distributionPassengersService.hasTooManyInfantsValidation" class="input-error -eva-3-mt-sm">
          <i class="eva-3-icon-warning"></i>
          <em class="input-error-message">{{ 'distributionPassengers.modal.moreInfantsThanAdults' | translate }}</em>
        </p>
      </div>
  `,
  styleUrls: ['./distribution-passengers-content-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DistributionPassengersContentModalComponent implements OnInit {

  @Input() distributionData: DistributionPassengers;

  model: InputModel[];
  modelSelector: InputModel[];

  constructor(private translateService: TranslateService,
    public distributionPassengersService: DistributionPassengersService) { }

  ngOnInit() {
    this.initializeModels();
  }

  initializeModels() {
    this.model = [
      {
        type: 'STEPPERS',
        key: 'adults',
        positionIndex: 0,
        label: this.translateService.instant("distributionPassengers.modal.adultText"),
        placeholder: this.translateService.instant("distributionPassengers.modal.adultDescription"),
        validations: {
          max: 7,
          min: 1,
          optional: false,
        },
        default_value: '1',
        options: []
      },
      {
        type: 'STEPPERS',
        key: 'minors',
        positionIndex: 1,
        label: this.translateService.instant("distributionPassengers.modal.minorText"),
        placeholder: this.translateService.instant("distributionPassengers.modal.minorDescription"),
        validations: {
          max: 7,
          min: 0,
          optional: false,
        },
        default_value: '0',
        options: []
      }
    ];

    this.modelSelector = Array.from({ length: 8 }, (_, i) => ({
      type: 'SELECTOR',
      key: `minorAge${i + 1}`,
      positionIndex: 2,
      css_class_names: ['-md'],
      label: this.translateService.instant("distributionPassengers.modal.minorAgeText", { age: i + 1 }),
      placeholder: this.translateService.instant("distributionPassengers.modal.minorAgeDescription"),
      validations: {
        max: 7,
        min: 1,
        optional: false,
      },
      default_value: 'none',
      options: [
        { name: this.translateService.instant("distributionPassengers.modal.selectAgeEmpty"), value: "", default_option: true },
        { name: this.translateService.instant("distributionPassengers.modal.selectAgeTo1"), value: "0", dynamic_text: this.resolveMinorAgesSubtitle(0) },
        ...Array.from({ length: 17 }, (_, j) => ({ name: `${j + 1}`, value: `${j + 1}`, dynamic_text: this.resolveMinorAgesSubtitle(j) }))
      ]
    }));
  }

  updateFormData() {
    const totalPassengers = this.distributionData.adults + this.distributionData.minors;
    const maxPassengers = 8;

    this.model[0].validations.max = totalPassengers < maxPassengers ? maxPassengers - this.distributionData.minors : this.distributionData.adults;
    this.model[1].validations.max = totalPassengers < maxPassengers ? maxPassengers - this.distributionData.adults : this.distributionData.minors;

    const minorsAgeKeys = this.distributionPassengersService.getMinorsAgeKeys(this.distributionData);

    if (this.distributionData.minors < minorsAgeKeys.length) {
      const minorAgeKey = `minorAge${minorsAgeKeys.length}`;
      delete this.distributionData[minorAgeKey];
    }
  }

  resolveMinorAgesSubtitle(age) {
    if (age == 0 || age == 1) {
      return this.translateService.instant("distributionPassengers.modal.selectDescriptionBaby");
    } else if (age >= 2 && age <= 11) {
      return this.translateService.instant("distributionPassengers.modal.selectDescriptionChild");
    } else {
      return this.translateService.instant("distributionPassengers.modal.selectDescriptionAdult");
    }
  }
}

